import * as mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

export default {
  namespaced: true,
  state () {
    return {
      from: null,
      to: null,
      period: 'MM',
      info: {
        labels: [],
        datasets: []
      }
    }
  },
  mutations,
  getters,
  actions
}
